import { useState, useRef, useEffect } from "react";
import styles from "./InfoPopup.module.css";


export default function InfoPopup ({info, alighRight=false, alignLeft=false, children}) {

    const [isVisible, setIsVisible] = useState(false);
    const timeoutRef = useRef(null);

    const handleMouseEnter = () => {
        timeoutRef.current = setTimeout(()=>{ setIsVisible(true); }, 100);
    }

    const handleMouseLeave = () => {
        clearTimeout(timeoutRef.current);
        setIsVisible(false);
    }

    return (
        <div className={styles.infoPopupWrapper} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>

            { isVisible && <div className={`${styles.infoPopupBox} ${alighRight && styles.alighRight} ${alignLeft && styles.alignLeft} `}> {info} </div> }

            { children }

        </div>
    )
}